import { Component, Input, Output, EventEmitter} from '@angular/core'

@Component({
  selector: 'app-st-button-excel',
  templateUrl: './st-button-excel.component.html',
  styleUrls: ['./st-button-excel.component.scss'],
  standalone: false
})
export class StButtonExcelComponent {

  @Input()
  idVal: string = 'buttonId';

  @Input()
  label = 'Export to Excel';

  @Output()
  onClick = new EventEmitter<Event>();
}
